import { FC } from "react"
import styles from "./DetailsTab.module.scss"
import { InviteCard, RewardsPanel } from "./ui"

export const DetailsTab: FC = () => {
  return (
    <div className={styles.DetailsTab}>
      <InviteCard />
      <RewardsPanel />
    </div>
  )
}
